import React, { useRef } from 'react';
import useOnScreen from '../../hooks/useOnScreen';

export default function Iframe({ ...props }) {
	const ref = useRef();
	const isVisible = useOnScreen(ref);
	return <div ref={ref}>{isVisible && <iframe title="video" {...props} loading="lazy" />}</div>;
}
